'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.modal = twentyninetimes.modal || function () {

	function init() {
		modalTrigger();
	}

	function modalTrigger(){
        var site_body		= document.body,
            modaltriggers    = document.getElementsByClassName('is-style-modal');


        for(var i = 0; i < modaltriggers.length; i++) {
            var modaltrigger = modaltriggers[i];
            modaltrigger.onclick = function(e) {

                var modalcontent = ''; // this. something....
                
                // fire function on click
                e.preventDefault();

                document.body.innerHTML +='<div class="modal"><div class="modal-content">'+modalcontent+'</div><button type="button">&times;</button></div><div class="modal-backdrop"></div>';
                




            }
        }

    }

	return {
		init : init
	};

}();